import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
    name: 'genderPipe',
    standalone: false
})
export class GenderPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  public transform(txt): string {
    if (txt === 'MALE') {
      return 'Male';
    } else if (txt === 'FEMALE') {
      return 'Female';
    } else if (txt === 'UNDIFFERENTIATED') {
      return 'Undifferentiated';
    }
    return '';
  }

}
